import { useNavigate } from "react-router-dom";
import { IoSettingsOutline, IoChevronDown } from "react-icons/io5";

const SocialProof = () => {
    const navigate = useNavigate();

    return (
        <div className="relative flex h-full w-full flex-col overflow-hidden">
            {/* Main content */}
            <div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 text-center">
                <div style={{ animation: "spin 6s linear infinite" }}>
                    <IoSettingsOutline size={80} className="text-[#89d0fb]" />
                </div>
                <h1 className="text-[32px] font-black text-black lg:text-[40px]">
                    Under Construction
                </h1>
                <p className="max-w-[400px] text-[15px] leading-[1.65] text-[#444444]">
                    The <strong>Social Proof</strong> page is coming soon.
                    Check back soon!
                </p>
            </div>

            {/* Bottom — next page nav */}
            <div className="flex items-center justify-center pb-6">
                <button
                    onClick={() => navigate("/about-us/our-team")}
                    className="flex items-center gap-1.5 text-[14px] font-semibold text-[#2E9DDA] hover:underline"
                >
                    Our team
                    <IoChevronDown className="text-[15px]" />
                </button>
            </div>
        </div>
    );
};

export default SocialProof;
